module.exports = __webpack_public_path__ + "img/harmonyOS_bg5.f3043e9d.jpg";